import FundCard from './FundCard';

export default FundCard;